import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { supabase } from "../config/supabaseClient";

// Async thunk to add new record to training_catalogue_data_types table
export const addTrainingTypeLog = createAsyncThunk(
  "trainingType/addTrainingTypeLog",
  async ({ companyId, type, trainingId }, { rejectWithValue }) => {
    try {
      // Insert into training_catalogue_data_types table
      const { data: insertData, error: insertError } = await supabase
        .from("training_catalogue_data_types")
        .insert({
          company_id: companyId,
          type: type,
          training_id: trainingId,
         
        })
        .select();

      if (insertError) {
        console.error("Error inserting into training_catalogue_data_types:", insertError);
        throw insertError;
      }


      return {
        logData: insertData[0],
      };
    } catch (error) {
      console.error("Error in addTrainingTypeLog:", error);
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk to update existing record in training_catalogue_data_types table
export const updateTrainingTypeLog = createAsyncThunk(
  "trainingType/updateTrainingTypeLog",
  async ({ id, companyId, type, trainingId }, { rejectWithValue }) => {
    try {

      // Update existing record in training_catalogue_data_types table
      const { data: updateData, error: updateError } = await supabase
        .from("training_catalogue_data_types")
        .update({
          company_id: companyId,
          type: type,
          training_id: trainingId,
          updated_at: new Date().toISOString(),
        })
        .eq("id", id)
        .select();

      if (updateError) {
        console.error("Error updating training_catalogue_data_types:", updateError);
        throw updateError;
      }


      return {
        logData: updateData[0],
      };
    } catch (error) {
      console.error("Error in updateTrainingTypeLog:", error);
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk to add new record with is_critical to training_catalogue_data_types table
export const addTrainingIsCriticalLog = createAsyncThunk(
  "trainingType/addTrainingIsCriticalLog",
  async ({ companyId, isCritical, trainingId }, { rejectWithValue }) => {
    try {
      // Insert into training_catalogue_data_types table
      const { data: insertData, error: insertError } = await supabase
        .from("training_catalogue_data_types")
        .insert({
          company_id: companyId,
          is_critical: isCritical,
          training_id: trainingId,
        })
        .select();

      if (insertError) {
        console.error("Error inserting into training_catalogue_data_types:", insertError);
        throw insertError;
      }

      return {
        logData: insertData[0],
      };
    } catch (error) {
      console.error("Error in addTrainingIsCriticalLog:", error);
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk to update existing record with is_critical in training_catalogue_data_types table
export const updateTrainingIsCriticalLog = createAsyncThunk(
  "trainingType/updateTrainingIsCriticalLog",
  async ({ id, companyId, isCritical, trainingId }, { rejectWithValue }) => {
    try {
      // Update existing record in training_catalogue_data_types table
      const { data: updateData, error: updateError } = await supabase
        .from("training_catalogue_data_types")
        .update({
          company_id: companyId,
          is_critical: isCritical,
          training_id: trainingId,
        })
        .eq("id", id)
        .select();

      if (updateError) {
        console.error("Error updating training_catalogue_data_types:", updateError);
        throw updateError;
      }

      return {
        logData: updateData[0],
      };
    } catch (error) {
      console.error("Error in updateTrainingIsCriticalLog:", error);
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  lastAdded: null,
  lastUpdated: null,
};

const trainingTypeSlice = createSlice({
  name: "trainingType",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearLastAdded: (state) => {
      state.lastAdded = null;
    },
    clearLastUpdated: (state) => {
      state.lastUpdated = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Add training type log
      .addCase(addTrainingTypeLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addTrainingTypeLog.fulfilled, (state, action) => {
        state.loading = false;
        state.lastAdded = action.payload;
        state.error = null;
      })
      .addCase(addTrainingTypeLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update training type log
      .addCase(updateTrainingTypeLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTrainingTypeLog.fulfilled, (state, action) => {
        state.loading = false;
        state.lastUpdated = action.payload;
        state.error = null;
      })
      .addCase(updateTrainingTypeLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add training is_critical log
      .addCase(addTrainingIsCriticalLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addTrainingIsCriticalLog.fulfilled, (state, action) => {
        state.loading = false;
        state.lastAdded = action.payload;
        state.error = null;
      })
      .addCase(addTrainingIsCriticalLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update training is_critical log
      .addCase(updateTrainingIsCriticalLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTrainingIsCriticalLog.fulfilled, (state, action) => {
        state.loading = false;
        state.lastUpdated = action.payload;
        state.error = null;
      })
      .addCase(updateTrainingIsCriticalLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearLastAdded, clearLastUpdated } = trainingTypeSlice.actions;
export default trainingTypeSlice.reducer;
